/*
 * BONQUERÉ — Size Guide interactions  (BNQ-WEB-0270 · Sprint 3.4.7)
 *
 * Progressive enhancement for the two interactive navigators on the Women/Men size guides:
 *   1. The CM/IN unit toggle — swaps every measurement cell between its centimetre and inch value,
 *      from a SINGLE authored data source (each cell carries data-sg-cm and data-sg-in, computed in
 *      snippets/bnq-size-cell.liquid). No tables are duplicated. The choice persists across the page
 *      and across visits (localStorage), and switching never reloads the page or moves the scroll.
 *   2. The category / subcategory / "view" selector — built from the size tables actually present, so
 *      it can never point at a chart that is not there. "View" smooth-scrolls to the chosen chart.
 *
 * The controls markup is `hidden` until this script runs, so a visitor without JavaScript never sees a
 * dead control; the tables still show centimetres and the rail navigation still works. Smooth scrolling
 * honours prefers-reduced-motion.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-sg-root]');
  if (!root) return;

  var UNIT_KEY = 'bnq-size-unit';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1 · UNIT TOGGLE ─────────────────────────────────────────────────────────────────────────── */
  var unitButtons = Array.prototype.slice.call(root.querySelectorAll('[data-sg-unit]'));
  var cells = Array.prototype.slice.call(root.querySelectorAll('[data-sg-cm][data-sg-in]'));

  function applyUnit(unit) {
    var toInches = unit === 'in';
    cells.forEach(function (cell) {
      cell.textContent = toInches ? cell.getAttribute('data-sg-in') : cell.getAttribute('data-sg-cm');
    });
    unitButtons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-sg-unit') === unit;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    try {
      localStorage.setItem(UNIT_KEY, unit);
    } catch (e) {
      /* storage may be unavailable (private mode) — the toggle still works for the session. */
    }
  }

  if (unitButtons.length) {
    unitButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyUnit(btn.getAttribute('data-sg-unit'));
      });
    });

    var storedUnit = null;
    try {
      storedUnit = localStorage.getItem(UNIT_KEY);
    } catch (e) {
      storedUnit = null;
    }
    /* Only override the default (cm) when a valid preference is stored. */
    if (storedUnit === 'in') applyUnit('in');
  }

  /* ── 2 · CATEGORY SELECTOR ───────────────────────────────────────────────────────────────────── */
  var controls = root.querySelector('[data-sg-controls]');
  var categorySelect = root.querySelector('[data-sg-category]');
  var subcategorySelect = root.querySelector('[data-sg-subcategory]');
  var viewButton = root.querySelector('[data-sg-view]');
  var tables = Array.prototype.slice.call(root.querySelectorAll('[data-sg-table]'));

  /* Reveal the controls now that the script is running; without it they stay hidden. */
  if (controls) controls.hidden = false;

  if (categorySelect && subcategorySelect && viewButton && tables.length) {
    /* Build an ordered map of group -> [ {label, anchor} ], in document order, de-duplicated. */
    var groups = [];
    var groupIndex = {};

    tables.forEach(function (table) {
      var group = (table.getAttribute('data-sg-group') || '').trim();
      var label = (table.getAttribute('data-sg-label') || '').trim();
      var anchor = (table.getAttribute('data-sg-anchor') || '').trim();
      if (!group || !label) return;

      if (!(group in groupIndex)) {
        groupIndex[group] = groups.length;
        groups.push({ name: group, items: [] });
      }
      groups[groupIndex[group]].items.push({ label: label, anchor: anchor });
    });

    if (!groups.length) return;

    /* Populate the category select. */
    groups.forEach(function (group) {
      var opt = document.createElement('option');
      opt.value = group.name;
      opt.textContent = group.name;
      categorySelect.appendChild(opt);
    });

    function resetSubcategory() {
      /* Remove all but the placeholder (first option). */
      while (subcategorySelect.options.length > 1) {
        subcategorySelect.remove(1);
      }
      subcategorySelect.selectedIndex = 0;
      subcategorySelect.disabled = true;
      viewButton.disabled = true;
    }

    categorySelect.addEventListener('change', function () {
      resetSubcategory();
      var name = categorySelect.value;
      if (!name) return;

      var group = groups[groupIndex[name]];
      if (!group) return;

      group.items.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item.anchor;
        opt.textContent = item.label;
        subcategorySelect.appendChild(opt);
      });
      subcategorySelect.disabled = false;
    });

    subcategorySelect.addEventListener('change', function () {
      viewButton.disabled = !subcategorySelect.value;
    });

    viewButton.addEventListener('click', function () {
      var anchorId = subcategorySelect.value;
      if (!anchorId) return;
      var target = document.getElementById(anchorId);
      if (!target) return;
      target.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'start'
      });
    });
  }
})();
